export default __webpack_public_path__ + "static/media/virtual-tour-slide-1-desktop.11f5aa9c.png";